const ensureTrailingSlash = value => `${value.replace(/\/+$/, '')}/`;

const previewApiUrl =
  process.env.REACT_APP_PREVIEW_MODE === 'true' && typeof window !== 'undefined'
    ? `${window.location.origin}/api/`
    : null;

const configuredApiUrl = process.env.REACT_APP_API_URL?.trim();
const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();
const browserOrigin = typeof window !== 'undefined' ? window.location.origin : null;

export const APP_URL = ensureTrailingSlash(
  (process.env.REACT_APP_PREVIEW_MODE === 'true' && typeof window !== 'undefined'
    ? window.location.origin
    : configuredBaseUrl) || 'https://dev.custodiy.com',
);

export const API_URL = ensureTrailingSlash(
  previewApiUrl
    || configuredApiUrl
    || (browserOrigin ? `${browserOrigin}/api` : `${APP_URL}api`),
);

export const SITE_URL = ensureTrailingSlash(
  process.env.REACT_APP_SITE_URL?.trim() || 'https://custodiy.com',
);
